import service from "./service";

export default {
    getSLCodes(){
        return service.get('/reference/sl');
    },
}